/**
 * Klaviyo Preorder Detection
 * Detects when Klaviyo shows a preorder popup (form RnKSQ6) and updates
 * the add-to-cart button text to "Pre-order".
 */
(function () {
  var PREORDER_TEXT = 'Pre-order';

  var buttonObserver = null;

  function findButtonTextEl() {
    var selectors = [
      'product-form-component button[name="add"] .add-to-cart-text__content span span',
      '[ref="addToCartButton"] .add-to-cart-text__content span span',
      'button[name="add"] .add-to-cart-text__content span span'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function applyPreorderText() {
    var textEl = findButtonTextEl();
    if (!textEl) return;
    if (textEl.textContent.trim() !== PREORDER_TEXT) {
      textEl.textContent = PREORDER_TEXT;
    }
  }

  function setPreorderButton() {
    applyPreorderText();
    // Watch for the theme overwriting the button text (morph/section rendering)
    if (!buttonObserver) {
      var form = document.querySelector('product-form-component');
      if (form) {
        buttonObserver = new MutationObserver(function () {
          applyPreorderText();
        });
        buttonObserver.observe(form, { childList: true, subtree: true, characterData: true });
      }
    }
  }

  function isKlaviyoPreorderForm(node) {
    if (node.nodeType !== 1) return false;
    // Check for the Klaviyo form with preorder content
    var form = node.querySelector
      ? node.querySelector('[data-testid^="klaviyo-form"]')
      : null;
    if (!form) {
      if (node.matches && node.matches('[data-testid^="klaviyo-form"]')) {
        form = node;
      }
    }
    if (!form) return false;
    // Check if form contains "PREORDER" text
    return form.textContent.indexOf('PREORDER') !== -1;
  }

  function isKlaviyoPreorderVisible() {
    var forms = document.querySelectorAll('[data-testid^="klaviyo-form"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].textContent.indexOf('PREORDER') !== -1) {
        return true;
      }
    }
    return false;
  }

  // Watch for Klaviyo injecting the preorder popup
  // Klaviyo may inject the container first and fill content later,
  // so we also poll briefly after detecting any Klaviyo form node.
  var detected = false;

  function checkAndSet() {
    if (isKlaviyoPreorderVisible()) {
      // Klaviyo preorder popup detected
      detected = true;
      setPreorderButton();
      observer.disconnect();
    }
  }

  function delayedCheck() {
    // Klaviyo can take time to render content inside the form
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      checkAndSet();
      if (detected || attempts >= 20) {
        clearInterval(interval);
      }
    }, 500);
  }

  var observer = new MutationObserver(function (mutations) {
    if (detected) return;
    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];
      for (var j = 0; j < mutation.addedNodes.length; j++) {
        var node = mutation.addedNodes[j];
        if (node.nodeType !== 1) continue;
        // Direct match
        if (isKlaviyoPreorderForm(node)) {
          detected = true;
          setPreorderButton();
          observer.disconnect();
          return;
        }
        // Klaviyo container detected but content not yet loaded — start polling
        var hasKlaviyoEl = node.querySelector
          ? node.querySelector('[data-testid^="klaviyo-form"]')
          : null;
        if (!hasKlaviyoEl && node.matches && node.matches('[data-testid^="klaviyo-form"]')) {
          hasKlaviyoEl = node;
        }
        if (hasKlaviyoEl) {
          delayedCheck();
          return;
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Also check on page load in case popup is already visible
  checkAndSet();
  // Start polling in case Klaviyo loads late
  if (!detected) {
    delayedCheck();
  }
})();
